/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Faq_Changeemail_Title2Inputs */

const en_usermanagement_help_faq_changeemail_title2 = /** @type {(inputs: Usermanagement_Help_Faq_Changeemail_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I change my primary email?`)
};

/**
* | output |
* | --- |
* | "How do I change my primary email?" |
*
* @param {Usermanagement_Help_Faq_Changeemail_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_faq_changeemail_title2 = /** @type {((inputs?: Usermanagement_Help_Faq_Changeemail_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Faq_Changeemail_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_faq_changeemail_title2(inputs)
});
export { usermanagement_help_faq_changeemail_title2 as "userManagement_help_faq_changeEmail_title" }